<template>
  <div class="tep-page">
    <!-- 顶部导航 -->
    <header class="tep-header">
      <div class="tep-header-inner">
        <div class="tep-brand">
          <div class="tep-logo-box">TRX</div>
          <div class="tep-brand-text">TRX自助能量租赁平台</div>
        </div>
        <nav class="tep-nav">
          <button
            v-for="item in navTabs"
            :key="item.id"
            type="button"
            class="tep-nav-btn"
            :class="{ 'tep-nav-btn--active': activeTab === item.id }"
            @click="scrollToSection(item.id)"
          >
            {{ item.label }}
          </button>
          <button type="button" class="tep-nav-btn" @click="onContact">联系客服</button>
        </nav>
      </div>
    </header>

    <!-- Hero -->
    <section class="tep-hero">
      <h1 class="tep-hero-title">安全可靠的TRX自助能量租赁平台</h1>
      <p class="tep-hero-sub">快速稳定助力您的每一次交易</p>
      <div class="tep-tip-bar">
        温馨提示：系统将按实时汇率换算，
        <span class="tep-accent">能量闪租</span> /
        <span class="tep-accent">U-T闪兑</span> /
        <span class="tep-accent">预存模式</span>
        均支持。
      </div>
    </section>

    <main class="tep-main">
      <!-- 能量闪租 -->
      <section :id="SECTION.flash" class="tep-card">
        <div id="flashTitle" class="tep-card-head">能量闪租，灵活方便</div>
        <div class="tep-card-body tep-cols">
          <div class="tep-col">
            <h3 class="tep-col-title">流程说明</h3>
            <ul class="tep-list">
              <li>选择自己想要的笔数及有效时间</li>
              <li>向平台能量租赁地址转入对应的数量</li>
              <li>转帐后2秒内到账能量</li>
              <li>有大额需求联系客服,有优惠</li>
            </ul>
          </div>
          <div class="tep-col">
            <h3 class="tep-col-title">立即下单</h3>
            <div class="tep-form-row">
              <label>选择笔数</label>
              <select v-model="flash.count" class="tep-input">
                <option v-for="opt in flashCountOptions" :key="opt.value" :value="opt.value">
                  {{ opt.label }}
                </option>
              </select>
            </div>
            <div class="tep-form-row">
              <label>有效期</label>
              <select v-model="flash.period" class="tep-input">
                <option v-for="opt in flashPeriodOptions" :key="opt.value" :value="opt.value">
                  {{ opt.label }}
                </option>
              </select>
            </div>
            <p class="tep-amount-line">
              需转金额：<strong class="tep-amount">{{ flashNeedDisplay }}</strong>
            </p>
            <div class="tep-toggle-row">
              <button
                type="button"
                class="tep-toggle"
                :class="{ 'tep-toggle--on': flash.currency === 'TRX' }"
                @click="flash.currency = 'TRX'"
              >
                TRX
              </button>
              <button
                type="button"
                class="tep-toggle"
                :class="{ 'tep-toggle--on': flash.currency === 'USDT' }"
                @click="flash.currency = 'USDT'"
              >
                USDT
              </button>
              <span class="tep-rate">TRX/USDT 实时：{{ trxUsdtRateText }}</span>
            </div>
            <div class="tep-form-row tep-inline">
              <div class="tep-inline-field">
                <label>接收能量地址</label>
                <input v-model="flash.address" class="tep-input" placeholder="留空就是本地址" />
                <p v-if="flashAddrHint" class="tep-hint-err">{{ flashAddrHint }}</p>
              </div>
              <button type="button" class="tep-btn tep-btn-primary" :disabled="ordering" @click="onFlashOrder">立即兑换</button>
            </div>
            <p class="tep-footnote">提交后将跳转到钱包支付页面，<strong>支付金额自动转为USDT</strong>。</p>
          </div>
        </div>
      </section>

      <!-- U-T闪兑 -->
      <section :id="SECTION.swap" class="tep-card">
        <div id="utTitle" class="tep-card-head">Tron波场在线 USDT换TRX 1U = {{ swapRateText }}Trx</div>
        <div class="tep-card-body tep-cols">
          <div class="tep-col">
            <h3 class="tep-col-title">说明</h3>
            <ul class="tep-list">
              <li>U换T最低 1U 起,暂不支持T换U</li>
              <li>获得数量 = 数量 * 汇率</li>
              <li>不再扣除手续费,转错可联系客服退款</li>
            </ul>
          </div>
          <div class="tep-col">
            <h3 class="tep-col-title">立即兑换</h3>
            <div class="tep-form-row tep-usdt-row">
              <span class="tep-usdt-label">USDT</span>
              <input v-model.number="swap.usdt" type="number" min="1" step="any" class="tep-input" />
            </div>
            <p class="tep-amount-line">
              可兑换：<strong class="tep-amount">{{ swapResultText }}</strong>
            </p>
            <div class="tep-form-row tep-inline">
              <div class="tep-inline-field">
                <label>接收地址</label>
                <input v-model="swap.address" class="tep-input" placeholder="留空就是本地址" />
                <p v-if="swapAddrHint" class="tep-hint-err">{{ swapAddrHint }}</p>
              </div>
              <button type="button" class="tep-btn tep-btn-primary" :disabled="ordering" @click="onSwapOrder">下单</button>
            </div>
            <p class="tep-footnote">支付金额：<strong>输入USDT金额</strong>（不做二次换算）。</p>
          </div>
        </div>
      </section>

      <!-- 预存模式 -->
      <section :id="SECTION.prepay" class="tep-card">
        <div id="depositTitle" class="tep-card-head">Trx笔数模式，省时省心</div>
        <div class="tep-card-body tep-cols">
          <div class="tep-col">
            <h3 class="tep-col-title">预存模式优势</h3>
            <ul class="tep-list">
              <li>系统随时保证您地址中有13.1万能量可用</li>
              <li>用一笔扣一笔,不用每次转帐前再租用能量</li>
              <li>3天不用自动暂停不再扣费,转U一次自动恢复</li>
              <li>您地址无带宽且无trx时发送345带宽给您</li>
            </ul>
          </div>
          <div class="tep-col">
            <h3 class="tep-col-title">预存获取笔数计算</h3>
            <div class="tep-form-row">
              <label>预存类型</label>
              <select v-model="prepay.type" class="tep-input">
                <option value="trx">预存TRX</option>
                <option value="usdt">预存USDT</option>
              </select>
            </div>
            <div class="tep-form-row">
              <label>输入数量</label>
              <input v-model.number="prepay.qty" type="number" min="1" step="any" class="tep-input" />
            </div>
            <p class="tep-rate-red">{{ prepayRatioHint }}</p>
            <p class="tep-amount-line">
              获得转账笔数：<strong class="tep-amount">{{ prepayCount }}</strong>
            </p>
            <div class="tep-form-row tep-inline">
              <div class="tep-inline-field">
                <label>接收地址</label>
                <input v-model="prepay.address" class="tep-input" placeholder="留空就是本地址" />
                <p v-if="prepayAddrHint" class="tep-hint-err">{{ prepayAddrHint }}</p>
              </div>
              <button type="button" class="tep-btn tep-btn-primary" :disabled="ordering" @click="onPrepayOrder">下单</button>
            </div>
            <div class="tep-form-row tep-inline">
              <div class="tep-inline-field">
                <label>查询下单地址</label>
                <input v-model="prepay.queryAddr" class="tep-input" placeholder="输入查询地址" />
              </div>
              <button type="button" class="tep-btn tep-btn-dark" @click="onPrepayQuery">查询</button>
            </div>
            <p class="tep-footnote">
              预存TRX：按实时汇率自动兑换为USDT支付<br />
              预存USDT：支付金额 = 输入USDT数量
            </p>
          </div>
        </div>
      </section>

      <!-- 能量API -->
      <section :id="SECTION.api" class="tep-card">
        <div id="apiTitle" class="tep-card-head">能量API 提供超低价能量</div>
        <div class="tep-card-body tep-cols">
          <div class="tep-col">
            <h3 class="tep-col-title">说明</h3>
            <ul class="tep-list">
              <li>API可成本价购买能量</li>
              <li>开户免费使用代理功能</li>
              <li>十亿级自有能量池</li>
              <li>稳定,廉价的能量供应</li>
              <li>开户及开发文档请联系客服</li>
            </ul>
          </div>
          <div class="tep-col">
            <h3 class="tep-col-title">注册开户：</h3>
            <div class="tep-form-row tep-inline">
              <div class="tep-inline-field">
                <label>账号明细</label>
                <input v-model="apiUsername" class="tep-input" placeholder="请输入API用户名" />
              </div>
              <button type="button" class="tep-btn tep-btn-primary" @click="onApiView">查看</button>
            </div>
            <p class="tep-footnote">点击查看API用户明细</p>
          </div>
        </div>
      </section>

      <!-- 加入代理 -->
      <section :id="SECTION.agent" class="tep-card">
        <div id="agentTitle" class="tep-card-head">Trx能量代理 回报丰厚</div>
        <div class="tep-card-body">
          <h3 class="tep-col-title">加入我们 · 共同发展</h3>
          <ul class="tep-list">
            <li>稳定能量资源，价格优势明显</li>
            <li>支持自助下单系统 / API / 代理分润</li>
            <li>可对接你的站点与机器人</li>
          </ul>
          <p class="tep-agent-tip">如需开通代理，请联系上方「联系客服」。</p>
        </div>
      </section>

      <!-- 关于平台 -->
      <section class="tep-card tep-card-plain">
        <div class="tep-card-body">
          <h2 class="tep-section-title">关于平台</h2>
          <div class="tep-features">
            <div v-for="f in features" :key="f.title" class="tep-feature">
              <div class="tep-feature-icon">{{ f.icon }}</div>
              <div class="tep-feature-title">{{ f.title }}</div>
              <div class="tep-feature-sub">{{ f.sub }}</div>
            </div>
          </div>
          <p class="tep-about-text">
            本平台是一个由 Tron 波场官方授权认证，安全可靠的 TRX 能量自助租赁平台。我们拥有波场超级节点及 TRON API 高速访问权限，
            并使用集群服务器与全球 CDN 网络搭建租赁系统，以确保高性能和稳定的服务。平台成立至今已稳定运营一年多，
            成为众多客户信赖的选择。平台以 24 小时全自动操作为特点，能够快速处理能量及在线兑换业务，为用户提供优质、顺畅的服务。
          </p>
          <div class="tep-about-cols">
            <ul class="tep-arrow-list">
              <li>官方授权，享受权益和保障。</li>
              <li>租赁方式灵活，满足大众需求。</li>
            </ul>
            <ul class="tep-arrow-list">
              <li>全球高速网络，流畅稳定。</li>
              <li>顶尖技术团队，持续更新与维护。</li>
            </ul>
          </div>
        </div>
      </section>

      <!-- 加入我们 -->
      <section class="tep-card tep-card-plain">
        <div class="tep-card-body">
          <h2 class="tep-section-title">加入我们 共同发展</h2>
          <div class="tep-join-grid">
            <div v-for="j in joinItems" :key="j.title" class="tep-join-item">
              <div class="tep-join-icon">{{ j.icon }}</div>
              <div>
                <div class="tep-join-title">{{ j.title }}</div>
                <div class="tep-join-desc">{{ j.desc }}</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 常见问题 -->
      <section class="tep-card tep-card-plain">
        <div class="tep-card-body">
          <h2 class="tep-section-title">常见问题</h2>
          <div v-for="(faq, idx) in faqs" :key="idx" class="tep-faq">
            <div class="tep-faq-q">
              <span class="tep-faq-icon">?</span>
              {{ faq.q }}
            </div>
            <p class="tep-faq-a">{{ faq.a }}</p>
          </div>
        </div>
      </section>
    </main>

    <footer class="tep-footer">
      <span class="tep-footer-badge">✓</span>
      已通过安全认证 Copyright ©
    </footer>

    <div v-if="showModal" class="tep-mask" @click.self="showModal = false">
      <div class="tep-modal">
        <div class="tep-modal-head">{{ modalTitle }}</div>
        <div class="tep-modal-body">{{ modalText }}</div>
        <button type="button" class="tep-modal-ok" @click="showModal = false">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, onUnmounted, reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { message } from 'ant-design-vue';
import { addOrder } from '../util/api';
import { resolveReferralContext } from '../util/deeplink';
import { makeOrderNo, pushSelectWallet } from '../util/paymentFlow';

const SECTION = {
  flash: 'flash',
  swap: 'ut',
  prepay: 'deposit',
  api: 'api',
  agent: 'agent',
};

export default {
  name: 'TrxEnergyPlatform',
  setup() {
    const route = useRoute();
    const router = useRouter();
    const activeTab = ref(SECTION.flash);
    const trxPriceUsd = ref(null); // 1 TRX = ? USDT
    const rateLoading = ref(true);
    const apiUsername = ref('');
    const ordering = ref(false);
    const referral_code = ref('');
    const gameGroupId = ref('');
    const flashAddrHint = ref('');
    const swapAddrHint = ref('');
    const prepayAddrHint = ref('');
    const showModal = ref(false);
    const modalTitle = ref('提示');
    const modalText = ref('');

    const DEFAULT_TRX_USDT = 1 / 4.82;

    const flashCountOptions = [
      { value: '1', label: '1笔转账能量' },
      { value: '2', label: '2笔转账能量' },
      { value: '3', label: '3笔转账能量' },
      { value: '4', label: '4笔转账能量' },
      { value: '5', label: '5笔转账能量' },
      { value: '10', label: '10笔转账能量' },
      { value: '20', label: '20笔转账能量' },
      { value: '30', label: '30笔转账能量' },
    ];

    const flashPeriodOptions = [
      { value: '0.5', label: '0.5TRX/1小时有效' },
      { value: '1.0', label: '1.0TRX/1天内有效' },
    ];

    const navTabs = [
      { id: SECTION.flash, label: '能量闪租' },
      { id: SECTION.swap, label: 'U-T闪兑' },
      { id: SECTION.prepay, label: '预存模式' },
      { id: SECTION.api, label: '能量API' },
      { id: SECTION.agent, label: '加入代理' },
    ];

    const flash = reactive({
      count: '1',
      period: '0.5',
      currency: 'TRX',
      address: '',
    });

    const swap = reactive({ usdt: 100, address: '' });
    const prepay = reactive({ type: 'trx', qty: 10, address: '', queryAddr: '' });

    const fmt2 = (x) => {
      const n = Number(x);
      if (!Number.isFinite(n)) return '0.00';
      return (Math.round(n * 100) / 100).toFixed(2);
    };
    const fmt6 = (x) => {
      const n = Number(x);
      if (!Number.isFinite(n)) return '0.000000';
      return (Math.round(n * 1e6) / 1e6).toFixed(6);
    };

    const isTronAddr = (addr) => /^T[1-9A-HJ-NP-Za-km-z]{33}$/.test(String(addr || '').trim());

    const flashNeedTrx = computed(() => {
      const c = parseInt(flash.count || '1', 10);
      const u = parseFloat(flash.period || '0.5');
      return c * u;
    });

    const flashPayUsdt = computed(() => {
      if (!trxPriceUsd.value) return 0;
      return flashNeedTrx.value * trxPriceUsd.value;
    });

    const flashNeedDisplay = computed(() => {
      if (flash.currency === 'USDT') {
        return trxPriceUsd.value ? `${fmt6(flashPayUsdt.value)} USDT` : '获取中...';
      }
      return `${fmt2(flashNeedTrx.value)} TRX`;
    });

    const trxUsdtRateText = computed(() => (
      rateLoading.value && !trxPriceUsd.value ? '获取中...' : fmt6(trxPriceUsd.value || DEFAULT_TRX_USDT)
    ));

    // 1 USDT = ? TRX（参考站：价格下浮 30% 后取倒数）
    const swapRate = computed(() => {
      if (!trxPriceUsd.value) return 0;
      const eff = trxPriceUsd.value * 0.7;
      return eff > 0 ? 1 / eff : 0;
    });

    const swapRateText = computed(() => (
      swapRate.value ? fmt2(swapRate.value) : '获取中...'
    ));

    const swapResultText = computed(() => {
      if (!swapRate.value) return '获取中...';
      const u = Number(swap.usdt) || 0;
      return `${fmt6(u * swapRate.value)} TRX`;
    });

    const prepayRatioHint = computed(() => (
      prepay.type === 'trx' ? '1TRX = 2笔转账' : '1USDT = 9笔转账'
    ));

    const prepayCount = computed(() => {
      const q = Number(prepay.qty) || 0;
      return Math.floor(prepay.type === 'trx' ? q * 2 : q * 9);
    });

    const prepayPayUsdt = computed(() => {
      const q = Number(prepay.qty) || 0;
      if (prepay.type === 'usdt') return q;
      return trxPriceUsd.value ? q * trxPriceUsd.value : 0;
    });

    const features = [
      { icon: '✓', title: '官方授权', sub: '已授权认证' },
      { icon: 'P', title: '高性价比', sub: '价格更优' },
      { icon: '⌂', title: '流畅稳定', sub: '全球高速网络' },
    ];

    const joinItems = [
      {
        icon: '⚡',
        title: '成为能量主',
        desc: '仅需提供您的续费账号的能量代理 / 回收权限，年利率达 20%~30%。',
      },
      {
        icon: '代',
        title: '成为代理',
        desc: '分配独立能量租赁地址、闪兑地址、独立推广页，佣金即时结算。',
      },
      {
        icon: '☰',
        title: '独立运营',
        desc: '帮助搭建整套系统，专业技术团队 24 小时支持，您只需专注发展业务。',
      },
    ];

    const faqs = [
      {
        q: '波场链上 USDT 转账手续费怎么算？',
        a: '转账时优先使用能量抵扣，如果没有能量则燃烧账号中的 TRX 进行抵扣。正常一笔 USDT 交易需要约 65000 能量或 13.4TRX 左右的手续费；如果对方账号没有 USDT 资产或未激活则需要 131000 能量或 26.5TRX 左右的手续费。',
      },
      {
        q: '能量有什么用？使用能量转账能节省多少手续费？',
        a: '能量可以抵扣转账手续费，一笔 USDT 转账在不使用能量的情况下大概需要 13.4TRX 的手续费；使用能量后费用大概就是 3.4 左右（租赁能量约 3TRX + 带宽费用约 0.345TRX），一笔交易大约能节省近 10TRX 的费用。',
      },
      {
        q: 'TRX 能量怎么获得？平台的能量从哪里来？',
        a: '能量通过质押 TRX 获得。每质押 1 个 TRX 大约获得 12.2 左右的能量（随质押数量增加该值会减少），因为能量每天发放总量固定。质押后 TRX 不能交易，要交易时需解压并等待 14 天。平台能量主要来自自有 TRX 质押及招募能量主提供的能量。',
      },
      {
        q: 'USDT 和 TRX 在线兑换的汇率怎么计算？',
        a: '汇率使用最新 TRX 价格计算，并每分钟更新一次；平台在收取少许手续费后得出最终兑换汇率。',
      },
      {
        q: '购买或兑换后不到账怎么办？',
        a: '请及时联系客服。虽然我们采用高性能集群服务器，但区块链原因偶尔会出现延迟或区块丢失情况，此类情况概率极低（约 10 万分之一）。',
      },
      {
        q: '购买后没有使用能量是否支持退款？',
        a: '不支持退款。购买时长笔数套餐到期后不论是否已使用能量都会自动回收为您质押的 TRX 和能量。',
      },
    ];

    const openTip = (title, text) => {
      modalTitle.value = title || '提示';
      modalText.value = text || '';
      showModal.value = true;
    };

    const scrollToSection = (id) => {
      activeTab.value = id;
      const el = document.getElementById(id);
      if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY - 72;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    };

    async function fetchTrxPrice() {
      try {
        const r = await fetch(
          'https://api.coingecko.com/api/v3/simple/price?ids=tron&vs_currencies=usd',
          { cache: 'no-store' },
        );
        const j = await r.json();
        if (j?.tron?.usd) return parseFloat(j.tron.usd);
      } catch {
        /* fallback */
      }
      try {
        const r = await fetch(
          'https://api.binance.com/api/v3/ticker/price?symbol=TRXUSDT',
          { cache: 'no-store' },
        );
        const j = await r.json();
        if (j?.price) return parseFloat(j.price);
      } catch {
        /* fallback */
      }
      return DEFAULT_TRX_USDT;
    }

    const refreshRate = async () => {
      rateLoading.value = true;
      try {
        trxPriceUsd.value = await fetchTrxPrice();
      } finally {
        rateLoading.value = false;
      }
    };

    const onContact = () => openTip('提示', '请联系客服');

    const submitOrder = async ({ title, price, inputGT }) => {
      if (ordering.value) return;
      const amount = Number(price);
      if (!amount || amount <= 0) {
        openTip('提示', '金额无效');
        return;
      }
      const data = {
        price: amount,
        inputNumber: 1,
        inputGT: inputGT || '',
        orderNo: makeOrderNo(),
        title,
        referral_code: referral_code.value,
      };
      ordering.value = true;
      try {
        await addOrder(data);
        pushSelectWallet(router, data, gameGroupId.value);
      } catch (e) {
        console.error(e);
        message.error('下单失败，请稍后重试');
      } finally {
        ordering.value = false;
      }
    };

    const onFlashOrder = () => {
      flashAddrHint.value = '';
      const addr = (flash.address || '').trim();
      if (addr && !isTronAddr(addr)) {
        flashAddrHint.value = '地址格式不正确，请输入34位波场地址（T开头）';
        return;
      }
      if (!trxPriceUsd.value) {
        openTip('提示', '汇率获取中，请稍后再试');
        return;
      }
      // 参考站：支付金额自动转为 USDT
      return submitOrder({
        title: `能量闪租-${flash.count}笔-${flash.period}TRX`,
        price: Number(fmt6(flashPayUsdt.value)),
        inputGT: addr,
      });
    };

    const onSwapOrder = () => {
      swapAddrHint.value = '';
      const addr = (swap.address || '').trim();
      if (addr && !isTronAddr(addr)) {
        swapAddrHint.value = '地址格式不正确，请输入34位波场地址（T开头）';
        return;
      }
      const u = Number(swap.usdt);
      if (!(u > 0)) {
        openTip('提示', '请输入有效的USDT金额');
        return;
      }
      if (u < 1) {
        openTip('提示', '最低兑换 1 USDT');
        return;
      }
      if (!trxPriceUsd.value) {
        openTip('提示', '汇率获取中，请稍后再试');
        return;
      }
      return submitOrder({
        title: `U-T闪兑-${u}USDT`,
        price: Number(fmt6(u)),
        inputGT: addr,
      });
    };

    const onPrepayOrder = () => {
      prepayAddrHint.value = '';
      const addr = (prepay.address || '').trim();
      if (addr && !isTronAddr(addr)) {
        prepayAddrHint.value = '地址格式不正确，请输入34位波场地址（T开头）';
        return;
      }
      const q = Number(prepay.qty);
      if (!(q > 0)) {
        openTip('提示', '请输入有效数量');
        return;
      }
      if (prepay.type === 'trx' && !trxPriceUsd.value) {
        openTip('提示', '汇率获取中，请稍后再试');
        return;
      }
      return submitOrder({
        title: `预存模式-${prepay.type}-${q}`,
        price: Number(fmt6(prepayPayUsdt.value)),
        inputGT: addr,
      });
    };

    const onPrepayQuery = () => {
      openTip('查询结果', '此地址无下单记录');
    };

    const onApiView = () => {
      if (!apiUsername.value.trim()) {
        openTip('提示', '请输入API用户名');
        return;
      }
      openTip('提示', '无此用户名');
    };

    const onScroll = () => {
      const ids = navTabs.map((t) => t.id);
      let current = ids[0];
      for (const id of ids) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= 100) {
          current = id;
        }
      }
      activeTab.value = current;
    };

    let rateTimer = null;
    onMounted(async () => {
      const ctx = resolveReferralContext(route);
      referral_code.value = ctx.referralCode;
      gameGroupId.value = ctx.gameGroupId;
      window.addEventListener('scroll', onScroll, { passive: true });
      const hash = (route.hash || window.location.hash || '').replace(/^#/, '');
      if (hash) {
        requestAnimationFrame(() => {
          const el = document.getElementById(hash);
          if (el) {
            const top = el.getBoundingClientRect().top + window.scrollY - 72;
            window.scrollTo({ top, behavior: 'smooth' });
          }
        });
      }
      await refreshRate();
      rateTimer = setInterval(refreshRate, 60 * 1000);
    });
    onUnmounted(() => {
      window.removeEventListener('scroll', onScroll);
      if (rateTimer) clearInterval(rateTimer);
    });

    return {
      SECTION,
      navTabs,
      activeTab,
      flash,
      swap,
      prepay,
      apiUsername,
      flashCountOptions,
      flashPeriodOptions,
      flashNeedDisplay,
      trxUsdtRateText,
      swapRateText,
      swapResultText,
      prepayRatioHint,
      prepayCount,
      features,
      joinItems,
      faqs,
      ordering,
      flashAddrHint,
      swapAddrHint,
      prepayAddrHint,
      showModal,
      modalTitle,
      modalText,
      scrollToSection,
      onContact,
      onFlashOrder,
      onSwapOrder,
      onPrepayOrder,
      onPrepayQuery,
      onApiView,
    };
  },
};
</script>

<style scoped>
.tep-page {
  min-height: 100vh;
  background: #181818;
  color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.tep-accent {
  color: #a3ff00;
}

/* Header */
.tep-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #181818;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.tep-header-inner {
  max-width: 1100px;
  margin: 0 auto;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.tep-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.tep-logo-box {
  width: 44px;
  height: 44px;
  background: #a3ff00;
  color: #111;
  font-weight: 800;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}

.tep-brand-text {
  color: #a3ff00;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
  max-width: 120px;
}

.tep-nav {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}

.tep-nav-btn {
  padding: 8px 14px;
  border: none;
  border-radius: 20px;
  background: #333333;
  color: #ffffff;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s;
  -webkit-tap-highlight-color: transparent;
}

.tep-nav-btn:hover,
.tep-nav-btn--active {
  background: #444444;
  outline: 1px solid #a3ff00;
}

/* Hero */
.tep-hero {
  max-width: 1100px;
  margin: 0 auto;
  padding: 36px 16px 24px;
  text-align: center;
}

.tep-hero-title {
  margin: 0 0 12px;
  font-size: clamp(22px, 5vw, 32px);
  font-weight: 800;
  background: linear-gradient(90deg, #00e5ff, #80deea);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-shadow: 0 0 30px rgba(0, 229, 255, 0.3);
}

.tep-hero-sub {
  margin: 0 0 20px;
  color: #cccccc;
  font-size: 15px;
}

.tep-tip-bar {
  display: inline-block;
  max-width: 100%;
  padding: 12px 20px;
  background: #ffffff;
  color: #333333;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.5;
}

/* Main */
.tep-main {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 16px 40px;
}

.tep-card {
  margin-bottom: 28px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.35);
}

.tep-card-head {
  background: #a3ff00;
  color: #111111;
  text-align: center;
  font-weight: 700;
  font-size: 16px;
  padding: 14px 16px;
}

.tep-card-body {
  background: #ffffff;
  color: #222222;
  padding: 24px 28px;
}

.tep-card-plain .tep-card-body {
  border-radius: 12px;
}

.tep-cols {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
}

.tep-col-title {
  margin: 0 0 14px;
  font-size: 16px;
  font-weight: 700;
}

.tep-list {
  margin: 0;
  padding-left: 18px;
  font-size: 14px;
  line-height: 1.8;
  color: #444444;
}

.tep-form-row {
  margin-bottom: 14px;
}

.tep-form-row label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  color: #555555;
}

.tep-input {
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #dddddd;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
  background: #ffffff;
}

.tep-amount-line {
  margin: 12px 0;
  font-size: 14px;
}

.tep-amount {
  color: #e53935;
  font-size: 22px;
  font-weight: 700;
}

.tep-toggle-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 14px;
}

.tep-toggle {
  padding: 6px 16px;
  border: 1px solid #cccccc;
  border-radius: 6px;
  background: #f0f0f0;
  cursor: pointer;
  font-size: 13px;
}

.tep-toggle--on {
  background: #111111;
  color: #ffffff;
  border-color: #111111;
}

.tep-rate {
  font-size: 12px;
  color: #888888;
}

.tep-rate-red {
  font-size: 13px;
  color: #e53935;
  margin: 0 0 8px;
}

.tep-inline {
  display: flex;
  gap: 10px;
  align-items: flex-end;
}

.tep-inline-field {
  flex: 1;
  min-width: 0;
}

.tep-btn {
  flex-shrink: 0;
  height: 40px;
  padding: 0 18px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}

.tep-btn-primary {
  background: #a3ff00;
  color: #111111;
}

.tep-btn-dark {
  background: #222222;
  color: #ffffff;
}

.tep-footnote {
  margin: 8px 0 0;
  font-size: 12px;
  color: #999999;
}

.tep-hint-err {
  margin: 6px 0 0;
  font-size: 12px;
  color: #e53935;
  line-height: 1.4;
}

.tep-mask {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.tep-modal {
  width: min(360px, 100%);
  background: #ffffff;
  color: #222222;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
}

.tep-modal-head {
  padding: 14px 16px;
  font-weight: 700;
  font-size: 16px;
  border-bottom: 1px solid #eee;
}

.tep-modal-body {
  padding: 18px 16px;
  font-size: 14px;
  line-height: 1.6;
  color: #444444;
  white-space: pre-wrap;
}

.tep-modal-ok {
  display: block;
  width: 100%;
  height: 44px;
  border: none;
  border-top: 1px solid #eee;
  background: #ffffff;
  color: #111111;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

.tep-modal-ok:hover {
  background: #f7f7f7;
}

.tep-usdt-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.tep-usdt-label {
  font-weight: 600;
  min-width: 48px;
}

.tep-agent-tip {
  margin-top: 16px;
  color: #666666;
  font-size: 14px;
}

.tep-section-title {
  text-align: center;
  margin: 0 0 28px;
  font-size: 22px;
  font-weight: 700;
}

.tep-features {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 24px;
  text-align: center;
}

.tep-feature-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 10px;
  border: 2px solid #a3ff00;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a3ff00;
  font-weight: 700;
  font-size: 20px;
}

.tep-feature-title {
  font-weight: 700;
  margin-bottom: 4px;
}

.tep-feature-sub {
  font-size: 13px;
  color: #888888;
}

.tep-about-text {
  font-size: 14px;
  line-height: 1.8;
  color: #444444;
  margin-bottom: 20px;
}

.tep-about-cols {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.tep-arrow-list {
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 14px;
  line-height: 2;
  color: #444444;
}

.tep-arrow-list li::before {
  content: '>';
  color: #a3ff00;
  margin-right: 8px;
  font-weight: 700;
}

.tep-join-grid {
  display: grid;
  gap: 20px;
}

.tep-join-item {
  display: flex;
  gap: 16px;
  padding: 16px;
  border: 1px solid #e8f5e9;
  border-radius: 10px;
  background: #fafafa;
}

.tep-join-icon {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border: 2px solid #a3ff00;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a3ff00;
  font-weight: 700;
  font-size: 18px;
}

.tep-join-title {
  font-weight: 700;
  margin-bottom: 6px;
}

.tep-join-desc {
  font-size: 13px;
  color: #666666;
  line-height: 1.6;
}

.tep-faq {
  margin-bottom: 20px;
}

.tep-faq-q {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 15px;
}

.tep-faq-icon {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  background: #a3ff00;
  color: #111;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
}

.tep-faq-a {
  margin: 0 0 0 32px;
  font-size: 14px;
  color: #555555;
  line-height: 1.7;
}

.tep-footer {
  text-align: center;
  padding: 24px 16px 32px;
  color: #888888;
  font-size: 13px;
}

.tep-footer-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background: #a3ff00;
  color: #111;
  border-radius: 50%;
  font-size: 11px;
  margin-right: 6px;
  vertical-align: middle;
}

@media (max-width: 768px) {
  .tep-page {
    padding-bottom: env(safe-area-inset-bottom);
  }

  .tep-header-inner {
    flex-direction: column;
    align-items: flex-start;
    padding: 10px 12px;
  }

  .tep-brand-text {
    max-width: none;
    font-size: 14px;
  }

  .tep-nav {
    width: 100%;
    overflow-x: auto;
    flex-wrap: nowrap;
    padding-bottom: 4px;
    -webkit-overflow-scrolling: touch;
  }

  .tep-nav-btn {
    flex-shrink: 0;
    font-size: 13px;
    padding: 8px 12px;
  }

  .tep-hero {
    padding: 28px 14px 18px;
  }

  .tep-hero-title {
    font-size: 22px;
    line-height: 1.35;
  }

  .tep-hero-sub {
    font-size: 14px;
  }

  .tep-tip-bar {
    font-size: 12px;
    line-height: 1.6;
  }

  .tep-main {
    padding: 0 12px 24px;
  }

  .tep-cols {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .tep-features {
    grid-template-columns: 1fr;
  }

  .tep-about-cols {
    grid-template-columns: 1fr;
  }

  .tep-inline {
    flex-direction: column;
    align-items: stretch;
  }

  .tep-btn {
    width: 100%;
    height: 44px;
  }

  .tep-input {
    font-size: 16px;
    height: 42px;
  }

  .tep-card-body {
    padding: 18px 14px;
  }

  .tep-card-head {
    font-size: 15px;
    padding: 12px 14px;
  }

  .tep-toggle-row {
    flex-wrap: wrap;
  }
}
</style>
